import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/api";
import { Btn, Modal, Pill } from "../comptabilite/_shared";
import { ACTION_CLS, ACTOR_LABEL, fmtTs } from "./AuditTable";

function Row({ label, children, testId }) {
  return (
    <div className="grid grid-cols-[130px_1fr] gap-2 text-xs py-1.5 border-b border-slate-100 last:border-0">
      <div className="text-slate-500 font-medium">{label}</div>
      <div className="text-slate-800 break-words min-w-0" data-testid={testId}>{children}</div>
    </div>
  );
}

export default function AuditDetail({ entry, onClose, onFilterEntity }) {
  const [full, setFull] = useState(null);
  useEffect(() => { api.get(`/audit/entries/${entry.id}`).then((r) => setFull(r.data)).catch(() => setFull(entry)); }, [entry]);
  const e = full || entry;
  const ent = e.entity || {};
  return (
    <Modal title={`${e.action_label} — ${e.module}`} sub={fmtTs(e.ts)} onClose={onClose} testId="audit-detail"
      footer={<>
        {ent.id && <Btn tone="slate" onClick={() => onFilterEntity(ent.id)} testId="audit-detail-filter-entity">Historique de cet élément</Btn>}
        <Btn tone="slate" onClick={onClose} testId="audit-detail-close-btn">Fermer</Btn>
      </>}>
      <div>
        <Row label="Acteur" testId="audit-detail-actor">{e.actor?.label} <span className="text-slate-400">· {ACTOR_LABEL[e.actor?.type] || e.actor?.type}{e.actor?.email ? ` · ${e.actor.email}` : ""}</span></Row>
        <Row label="Action"><Pill cls={ACTION_CLS[e.action] || ACTION_CLS.action}>{e.action_label}</Pill></Row>
        <Row label="Résultat" testId="audit-detail-status">{e.ok ? <span className="text-emerald-700 font-semibold">Réussie (HTTP {e.status})</span> : <span className="text-rose-700 font-semibold">Refusée / erreur (HTTP {e.status})</span>}{e.error && <div className="text-rose-600 mt-0.5">{e.error}</div>}</Row>
        {e.summary && <Row label="Détail" testId="audit-detail-summary">{e.summary}</Row>}
        {ent.kind && <Row label="Entité" testId="audit-detail-entity">{ent.kind}{ent.id ? <span className="font-mono text-[11px]"> · {ent.id}</span> : ""}</Row>}
        {ent.master_label && <Row label="Dossier">{ent.master_label}</Row>}
        <Row label="Requête"><span className="font-mono text-[11px]">{e.method} {e.path}</span>{e.query && Object.keys(e.query).length > 0 && <div className="font-mono text-[10px] text-slate-500">?{new URLSearchParams(e.query).toString()}</div>}</Row>
        <Row label="Adresse IP">{e.ip}</Row>
        {e.ua && <Row label="Navigateur"><span className="text-[11px] text-slate-500">{e.ua}</span></Row>}
        <Row label="Durée">{e.duration_ms} ms</Row>
      </div>
      <div>
        <div className="text-[11px] font-semibold text-slate-600 mb-1">Données transmises</div>
        {full === null ? <Loader2 className="w-4 h-4 animate-spin text-slate-400" /> : e.payload ? (
          <pre className="bg-slate-900 text-slate-100 rounded-lg p-3 text-[11px] overflow-x-auto max-h-80" data-testid="audit-detail-payload">{JSON.stringify(e.payload, null, 2)}</pre>
        ) : <p className="text-xs text-slate-400" data-testid="audit-detail-payload">Aucune donnée dans le corps de la requête.</p>}
      </div>
    </Modal>
  );
}
